import { sdkApi } from 'redux-stores/api';
import TCClient from 'client';
import { type PersonaSearchResponse } from 'js-sdk/src/types/Persona';

const personasApi = sdkApi.injectEndpoints({
  endpoints: (build) => ({
    findPersonas: build.query<
      PersonaSearchResponse,
      { orgId: string; searchValue: string; startIndex: number; count: number }
    >({
      queryFn: async ({ orgId, searchValue, startIndex, count }, _queryApi) => {
        const res = await TCClient.persona.findPersonas({
          organizationId: orgId || '',
          persona_name: searchValue,
          page: startIndex,
          pageSize: count,
        });
        return { data: res };
      },
      forceRefetch({ currentArg, previousArg }) {
        return true;
      },
    }),
  }),
});

export const { useFindPersonasQuery } = personasApi;
